import React, {FC, useEffect, useState} from "react";
import {
    Box,
    Button,
    Input,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Radio,
    RadioGroup,
    Stack,
    Text,
    VStack
} from "@chakra-ui/react";
import {Order} from "../../shared/entities/Order/Order";
import {useAppSelector} from "../../redux/Store";

interface ReorderInvoiceModalProps {
    isOpen: boolean;
    onClose: () => void;
    order: Order | null;
    onConfirm: (data: { poNumber: string; roNumber: string; useAdmin: number }) => void;
}

export const ReorderInvoiceModal: FC<ReorderInvoiceModalProps> = ({
                                                                      isOpen,
                                                                      onClose,
                                                                      order,
                                                                      onConfirm
                                                                  }) => {
    const currentUser = useAppSelector(store => store.AuthReducer.user);
    const [poNumber, setPoNumber] = useState<string>("");
    const [roNumber, setRoNumber] = useState<string>("");
    const [useAdmin, setUseAdmin] = useState<string>("admin"); // По умолчанию администратор

    // Устанавливаем значения по умолчанию из заказа при открытии модалки
    useEffect(() => {
        if (isOpen && order) {
            setPoNumber(order.poNumber || "");
            setRoNumber(order.namePo || "");
        }
    }, [isOpen, order]);

    // Проверяем, совпадают ли значения с исходными из заказа
    const isPoNumberSame = order && poNumber.trim() === (order.poNumber || "");
    const isRoNumberSame = order && roNumber.trim() === (order.namePo || "");

    const handleConfirm = () => {
        onConfirm({
            poNumber: poNumber.trim(),
            roNumber: roNumber.trim(),
            useAdmin: (useAdmin === "admin") ? Number(currentUser?.id) : Number(order?.user?.id)
        });
    };

    const handleClose = () => {
        setPoNumber("");
        setRoNumber("");
        setUseAdmin("admin");
        onClose();
    };
    return (
        <Modal isOpen={isOpen} onClose={handleClose} size="md">
            <ModalOverlay/>
            <ModalContent>
                <ModalHeader>Reorder Invoice #{order?.id}</ModalHeader>
                <ModalCloseButton/>
                <ModalBody>
                    <VStack spacing={4} align="stretch">
                        <Box>
                            <Text fontSize="sm" fontWeight="medium" mb={2}>
                                PO#
                            </Text>
                            <Input
                                value={poNumber}
                                onChange={(e) => setPoNumber(e.target.value)}
                                placeholder="Enter PO number"
                                size="md"
                                borderColor={isPoNumberSame ? "orange.400" : undefined}
                                focusBorderColor={isPoNumberSame ? "orange.500" : undefined}
                                _hover={{borderColor: isPoNumberSame ? "orange.500" : undefined}}
                            />
                            {isPoNumberSame && (
                                <Text fontSize="xs" color="orange.500" mt={1}>
                                    Same as original order - consider changing
                                </Text>
                            )}
                        </Box>
                        <Box>
                            <Text fontSize="sm" fontWeight="medium" mb={2}>
                                RO#
                            </Text>
                            <Input
                                value={roNumber}
                                onChange={(e) => setRoNumber(e.target.value)}
                                placeholder="Enter RO number"
                                size="md"
                                borderColor={isRoNumberSame ? "orange.400" : undefined}
                                focusBorderColor={isRoNumberSame ? "orange.500" : undefined}
                                _hover={{borderColor: isRoNumberSame ? "orange.500" : undefined}}
                            />
                            {isRoNumberSame && (
                                <Text fontSize="xs" color="orange.500" mt={1}>
                                    Same as original order - consider changing
                                </Text>
                            )}
                        </Box>
                        {!order?.user?.isAdmin &&
                            <Box>
                                <Text fontSize="sm" fontWeight="medium" mb={2}>
                                    Order on behalf of
                                </Text>
                                <RadioGroup onChange={setUseAdmin} value={useAdmin}>
                                    <Stack direction="column" spacing={2}>
                                        <Radio value="admin" size="md">
                                            Administrator
                                        </Radio>
                                        <Radio value="user" size="md">
                                            {order?.user?.name || "User"}
                                        </Radio>
                                    </Stack>
                                </RadioGroup>
                            </Box>
                        }
                    </VStack>
                </ModalBody>
                <ModalFooter>
                    <Button colorScheme="blue" mr={3} onClick={handleConfirm}>
                        Confirm
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

